// reducers/case/company.js
import { CREATE_COMPANY, RETRIEVE_COMPANIES, UPDATE_COMPANY } from '../../actions/types';

const initialState = [];

function companyReducer(companies = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CREATE_COMPANY:
            return [...companies, payload];
        case RETRIEVE_COMPANIES:
            return payload;
        case UPDATE_COMPANY:
            return companies.map((company) => {
                if (company.id === payload.id) {
                    return {
                        ...company,
                        ...payload,
                    };
                } else {
                    return company;
                }
            });
        default:
            return companies;
    }
}

export default companyReducer;
